import {combineReducers} from 'redux';
import { reducer as reduxFormReducer} from 'redux-form';
import layout from './layout';
import address from './address';

const reducers = combineReducers({
    layout,
    address,
    form: reduxFormReducer.plugin({
        PrequalForm: (state, action) => {
            switch(action.type) {
                case '@@redux-form/CHANGE':
                    // have to check for action.payload here since it might be null or ""
                    if(action.meta.field == 'street' && action.payload && action.payload.suggestSelect) {
                        let address_components = action.payload.gmaps.address_components.reduce((carry, component) => {
                            if (component.types[0] == 'locality') {
                                carry[component.types[0]] = component.long_name;
                            } else {
                                carry[component.types[0]] = component.short_name;
                            }
                            return carry;
                        }, {});
                        return {
                            ...state,
                            values: {
                                ...state.values,
                                street: [address_components.street_number, address_components.route].join(' '),
                                zip: [
                                        address_components.postal_code, 
                                        address_components.postal_code_suffix
                                    ].filter((e) => (e != null))
                                    .join('-')
                            }
                        }
                    }
                    return state;
                case 'RECEIVED_ADDRESS':
                    if(action.payload 
                        && action.payload.validation_response 
                        && action.payload.validation_response.address
                    ) {
                        let verified = action.payload.validation_response.address;
                        let service_type = (verified.metadata.rdi == 'Commercial' 
                            ? 'business' 
                            : 'residential' 
                        );

                        return {
                            ...state,
                            values: {
                                ...state.values,
                                service_type: service_type,
                            }   
                        }
                    
                    }
                    return state;
                default:
                    return state;
            }
        }
    })
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js